/*
 * @Author: wsx
 * @Date: 2022-01-15 16:39:06
 * @LastEditTime: 2022-01-23 14:58:05
 * @LastEditors: your name
 * @Description:
 */
export default [
  {
    path: "threeSolidHome",
    name: "threeSolidHome",
    component: () => import("@/views/threeSolid/threeSolidHome.vue"),
    meta: {
      title: "地图概览"
    }
  },
  {
    path: "dataAnalysis",
    name: "dataAnalysis",
    component: () => import("@/views/dataAnalysis/dataAnalysis.vue"),
    meta: {
      title: "数据分析"
    }
  },
  {
    path: "dataAnalysisOther",
    name: "dataAnalysisOther",
    component: () => import("@/views/dataAnalysisOther/dataAnalysisOther.vue"),
    meta: {
      title: "数据分析其他"
    }
  },
  {
    path: "dataStatisticsP",
    name: "dataStatisticsP",
    component: () =>
      import("@/views/threeSolid/realPopulation/dataStatisticsP.vue"),
    meta: {
      title: "数据统计"
    }
  },
  {
    path: "DemographicInformation",
    name: "DemographicInformation",
    component: () =>
      import("@/views/threeSolid/realPopulation/DemographicInformation.vue"),
    meta: {
      title: "人口信息"
    }
  },
  {
    path: "dataStatisticsH",
    name: "dataStatisticsH",
    component: () => import("@/views/threeSolid/realHouse/dataStatisticsH.vue"),
    meta: {
      title: "数据统计"
    }
  },
  {
    path: "houseInformation",
    name: "houseInformation",
    component: () =>
      import("@/views/threeSolid/realHouse/HouseInformation.vue"),
    meta: {
      title: "房屋信息"
    }
  },
  {
    path: "dataStatisticsU",
    name: "dataStatisticsU",
    component: () => import("@/views/threeSolid/realUnit/dataStatisticsU.vue"),
    meta: {
      title: "数据统计"
    }
  },
  {
    path: "UnitInformation",
    name: "UnitInformation",
    component: () => import("@/views/threeSolid/realUnit/UnitInformation.vue"),
    meta: {
      title: "单位信息"
    }
  },
  {
    path: "CommunityManagement",
    name: "CommunityManagement",
    component: () => import("@/views/threeSolid/CommunityManagement.vue"),
    meta: {
      title: "小区管理"
    }
  },
  {
    path: "PropertyManagementPersonnel",
    name: "PropertyManagementPersonnel",
    component: () =>
      import("@/views/threeSolid/PropertyManagementPersonnel.vue"),
    meta: {
      title: "物业人员管理"
    }
  },
  {
    path: "PersonnelVehicleInformation",
    name: "PersonnelVehicleInformation",
    component: () =>
      import("@/views/threeSolid/PersonnelVehicleInformation.vue"),
    meta: {
      title: "车辆人员信息"
    }
  },
  {
    path: "collectionStatistics",
    name: "collectionStatistics",
    component: () => import("@/views/threeSolid/collectionStatistics.vue"),
    meta: {
      title: "采集统计"
    }
  },
  {
    path: "ActualSecurityFacilities",
    name: "ActualSecurityFacilities",
    component: () => import("@/views/threeSolid/ActualSecurityFacilities.vue"),
    meta: {
      title: "实有安防设施"
    }
  },
  {
    path: "realPoliceIncident",
    name: "realPoliceIncident",
    component: () => import("@/views/threeSolid/realPoliceIncident.vue"),
    meta: {
      title: "实有警情事件"
    }
  },
  {
    path: "realPower",
    name: "realPower",
    component: () =>
      import("@/views/threeSolid/realPowerEquipment/realPower.vue"),
    meta: {
      title: "实有力量"
    }
  },
  {
    path: "actualEquipment",
    name: "actualEquipment",
    component: () =>
      import("@/views/threeSolid/realPowerEquipment/actualEquipment.vue"),
    meta: {
      title: "实有装备"
    }
  },
  {
    path: "fileManagement",
    name: "fileManagement",
    component: () => import("@/views/threeSolid/fileManagement.vue"),
    meta: {
      title: "档案管理"
    }
  },
  {
    path: "dataQuery",
    name: "dataQuery",
    component: () => import("@/views/threeSolid/dataQuery.vue"),
    meta: {
      title: "数据查询"
    }
  }
  // fileManagement
];
